module.exports = __webpack_public_path__ + "static/media/ubicacion_white.115617a5.svg";